import { useDebugValue } from 'react';
import { useClauseFieldPath } from './useClauseFieldPath';

export const useClauseCombinatorFieldPath = () => {
  const clauseFieldPath = useClauseFieldPath();
  const fieldPath = `${clauseFieldPath}.combinator` as const;
  useDebugValue(fieldPath);
  return fieldPath;
};
